import React, { useState, useEffect } from 'react'
import { ButtonHLPure, DialogSystemGLPure, GridPure, HeaderHLPure, SimpleLoading } from '../../pures';
import { Container, Grid, useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import './clients-dashboard-profile.css'
import { BranchOfficeMap, DashboardDateFilter, ItemsGraph, StatCard } from '../../pures/dashboard';
import { GENDERS } from '../../pures/dashboard/genders-legend';

function ClientsDashboardProfileView(props) {
    const {
        isLoading,
        errorMessage,
        toggleError,
        dashboardData1,
        dashboardData2,
        ticketsData,
        dates,
        handleDateChange,
        handleSearch,
        handleBack,
        handleViewTicket,
        setData,
        isDataDashboard
    } = props;

    const { t, i18n } = useTranslation('clients-dashboard', { keyPrefix: 'clientProfileScreen' });
    const { t: tCommon } = useTranslation('common');

    const hideActions = useMediaQuery('(max-width: 820px)');

    const gender = GENDERS.find(gender => gender === dashboardData1?.user.gender)
    const [userPreferences, setUserPreferences] = useState('')

    useEffect(() => {
        if (dashboardData1) {
            const auxUserPreferences = dashboardData1.user.consumerPreferences.split(',').map((consumerPreference) => {
                return tCommon(consumerPreference.trim())
            }).join(', ')

            setUserPreferences(auxUserPreferences)
        }
    }, [i18n.language, dashboardData1])

    return (
        <>
            <DialogSystemGLPure
                toggleErrorRequesting={toggleError}
                showErrorRequesting={!!errorMessage}
                messageError={errorMessage}
            />
            {
                isLoading
                    ? <div className='loading'>
                        <SimpleLoading />
                    </div>
                    : <div className={"dashboardView"}>
                        <Container>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <HeaderHLPure title={t("title")} />
                                </Grid>

                                <Grid item xs={12} className='clientsDashboardProfileView-user'>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} lg={6}>
                                            <p><strong>{tCommon("name")}</strong>: {dashboardData1.user.fullName}</p>
                                        </Grid>
                                        <Grid item xs={12} sm={4} lg={2}>
                                            <p><strong>{t("age")}</strong>: {dashboardData1.user.age} {t("years")}</p>
                                        </Grid>
                                        <Grid item xs={12} sm={4} lg={2}>
                                            <p><strong>{t("gender")}</strong>: {tCommon(gender)}</p>
                                        </Grid>
                                        <Grid item xs={12} sm={4} lg={2}>
                                            <p><strong>{t("zipCode")}</strong>: {dashboardData1.user.postalCode}</p>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <p><strong>{t("preferences")}</strong>: {userPreferences}</p>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} className="clientsDashboardProfileView-dashboard">
                                    <div className='clientsDashboardProfileView-stats'>
                                        <DashboardDateFilter dates={dates} handleChangeDate={handleDateChange} handleSearch={handleSearch} />

                                        <StatCard className="cdbp-amount"
                                            title={t("averageAmount")}
                                            value={(!dashboardData1.total_average && dashboardData1.total_average !== 0) ? "N/D" : `$${parseFloat(dashboardData1.total_average).toFixed(2)}`}
                                        />

                                        <StatCard className="cdbp-time"
                                            title={t("averageTime")}
                                            value={(!dashboardData1.time_average && dashboardData1.time_average !== 0) ? "N/D" : `${dashboardData1.time_average.toFixed(2)} ${t('day', { count: dashboardData1.time_average <= 1 ? 1 : 0 })}`}
                                        />

                                        <StatCard className="cdbp-value"
                                            title={t("clientValue")}
                                            value={(!dashboardData1.customer_value && dashboardData1.customer_value !== 0) ? "N/D" : <>${dashboardData1.customer_value.toFixed(2)} <span class="small-value">/{t('day', { count: 1 })}</span></>}
                                        />
                                    </div>

                                    <div className='clientsDashboardProfileView-graphs'>
                                        <ItemsGraph data={dashboardData1?.items} />

                                        <div className="dashboardView-card cdbp-map">
                                            <p className="dashboardView-card-title">{t("saleLocations")}</p>
                                            <BranchOfficeMap data={dashboardData2} />
                                        </div>
                                    </div>
                                </Grid>

                                <Grid item xs={12} style={{ marginTop: 24 }}>
                                    <HeaderHLPure headingNumber={2} title="Tickets" />
                                </Grid>

                                <Grid item xs={12} style={{ display: "grid" }}>
                                    <GridPure
                                        className="clientsDashboardProfileView-grid"
                                        loading={isLoading.ticketsData}
                                        dataGrid={ticketsData}
                                        setData={setData}
                                        isDataDashboard={isDataDashboard}
                                        skip={0}
                                        take={6}
                                        rowsItems={[
                                            {
                                                field: 'id',
                                                width: 200,
                                                title: 'ID',
                                                // locked: true,
                                                sorteable: true
                                            },
                                            {
                                                field: 'ticketNumber',
                                                width: 200,
                                                title: t("ticketNumber"),
                                                sorteable: true
                                            },
                                            {
                                                field: 'branchOfficeAssociated.name',
                                                width: 200,
                                                title: t("branchOffice"),
                                                sorteable: true
                                            },
                                            {
                                                field: 'date',
                                                title: t("date"),
                                                format: "date",
                                                width: 190,
                                                sorteable: true

                                            },
                                            {
                                                field: 'amount',
                                                title: t("amount"),
                                                format: "currency",
                                                width: 120,
                                                sorteable: true
                                            },
                                            {
                                                field: 'Acciones',
                                                title: hideActions ? '' : tCommon("actions"),
                                                actions: true,
                                                locked: true,
                                                width: hideActions ? 80 : 200,
                                                headerClassName: 'actionHeader'
                                            }
                                        ]}
                                        actions={[
                                            {
                                                type: 'label',
                                                value: tCommon('export'),
                                                onClick: (dataItem) => { console.log('Details...', dataItem) }
                                            },
                                            {
                                                type: 'view-details',
                                                value: tCommon('details'),
                                                onClick: handleViewTicket
                                            }
                                        ]}
                                    />
                                </Grid>

                                <Grid item xs={12} style={{ display: 'flex' }} justifyContent='flex-end'>
                                    <ButtonHLPure nameBtn={tCommon("back")} outlined colorScheme="primary" onClick={handleBack} />
                                </Grid>
                            </Grid>
                        </Container>
                    </div>
            }
        </>
    )
}

export default ClientsDashboardProfileView